import DOMPurify from 'dompurify';

const FORBIDDEN_TAGS = ['form', 'input', 'button', 'select', 'textarea', 'style'];

const purifier = DOMPurify(window);

purifier.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A' && node.hasAttribute('target')) {
    node.setAttribute('rel', 'noopener noreferrer');
  }
});

export const sanitizeHtml = (html) =>
  purifier.sanitize(html ?? '', {
    USE_PROFILES: { html: true },
    FORBID_TAGS: FORBIDDEN_TAGS,
    ADD_ATTR: ['target'],
  });
